/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { smallerDependencies } from './dependenciesSmaller.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createMin } from '../../factoriesAny.js';
export var minDependencies = {
  smallerDependencies: smallerDependencies,
  typedDependencies: typedDependencies,
  createMin: createMin
};